import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var InventoryOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M4.79167 2.5C4.49583 2.5 4.22143 2.65758 4.07227 2.91341L2.61393 5.41341C2.53977 5.54091 2.5 5.68583 2.5 5.83333V15.8333C2.5 16.7525 3.2475 17.5 4.16667 17.5H10.2458C10.0883 16.9717 10 16.4125 10 15.8333H4.16667V7.5H15.8333V10C16.4125 10 16.9717 10.0883 17.5 10.2458V5.83333C17.5 5.68583 17.4602 5.54091 17.3861 5.41341L15.9277 2.91341C15.7786 2.65758 15.5042 2.5 15.2083 2.5H4.79167ZM5.27018 4.16667H14.7298L15.7015 5.83333H4.2985L5.27018 4.16667ZM7.5 9.16667V10.8333H12.5V9.16667H7.5ZM15.8333 11.6667C13.5325 11.6667 11.6667 13.5325 11.6667 15.8333C11.6667 18.1342 13.5325 20 15.8333 20C18.1342 20 20 18.1342 20 15.8333C20 13.5325 18.1342 11.6667 15.8333 11.6667ZM17.5423 13.8753L18.7077 15.0423L15.4167 18.3333L12.959 15.8757L14.1243 14.7087L15.4167 15.9993L17.5423 13.8753Z",
    fill: fill
  }));
};
export { InventoryOutline as default };
//# sourceMappingURL=InventoryOutline.js.map
